import * as Sentry from "@sentry/browser";

export default {
  error(error: string, errorInfo: any) {
    console.log(errorInfo instanceof Error);
    Sentry.withScope((scope) => {
      scope.setTransactionName(error);
      if (errorInfo instanceof Error) {
        Sentry.captureException(errorInfo);
      } else if (typeof errorInfo === "object") {
        if (errorInfo.message) {
          Sentry.captureException(new Error(errorInfo.message));
        } else {
          Sentry.captureException(new Error(error), {
            extra: errorInfo,
          });
        }
      }
    });
    console.error(error, errorInfo);
  },

  info(message: string) {
    Sentry.captureMessage(message, Sentry.Severity.Info);
    console.info(message);
  },

  log(log: any) {
    console.log(JSON.stringify(log));
  },
};
